<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link :to="backRoute" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.Prices") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="vx-row" v-if="!editToggle">
      <vx-card>
        <div>
          <h4 class="pl-0 -ml-3 mb-2">{{ $t("setup.label.planPrice") }}</h4>
          <div class="vx-row less-padding">
            <div class="vx-col w-3/5 less-padding">
              <div class="vx-row border-left heading">
                <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                  {{ $t("setup.label.PlanCode") }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                  {{ $t("setup.label.ProductCode") }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                  {{ $t("setup.label.ChargeCode") }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                  {{ $t("setup.label.ChargeOwner") }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                  {{ $t("setup.label.Resource") }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                  {{ $t("setup.label.RoundingType") }}
                </div>
              </div>
            </div>
            <div class="vx-col w-2/5 less-padding">
              <div class="vx-row border-left heading" style="height: 100%">
                <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3">
                  {{ $t("setup.label.Duration") }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3">
                  {{ $t("setup.label.GLID") }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3">
                  {{ $t("setup.label.Value") }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="vx-row less-padding"
            :key="index"
            :data="priceEl"
            v-for="(priceEl, index) in planPriceList"
          >
            <div class="vx-col w-3/5 less-padding">
              <div class="vx-row border-left py-2" style="height: 100%">
                <div
                  class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6"
                  style="word-wrap: break-word"
                >
                  {{ priceEl.planCode }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                  {{ priceEl.productCode }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                  {{ priceEl.chargeCode }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                  {{ priceEl.chargeOwner }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                  {{ priceEl.currencyCode }}
                </div>
                <div
                  class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6"
                  style="word-wrap: break-word"
                >
                  {{ priceEl.roundingType }}
                </div>
              </div>
            </div>

            <div class="vx-col w-2/5 less-padding">
              <div class="vx-row border-left py-2" style="height: 100%">
                <!-- <div class="vx-col w-full sm:w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4">
                  <span class="ml-1">
                    {{ getDiscountCode(priceEl.discountId) }}</span
                  >
                </div> -->
                <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3">
                  {{ priceEl.duration }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3">
                  {{ priceEl.glId }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3">
                  {{ priceEl.price }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-8">
          <h4 class="pl-0 -ml-3 mb-2">{{ $t("setup.label.ProductPrice") }}</h4>
          <div class="vx-row less-padding">
            <div class="vx-col w-3/5 less-padding">
              <div class="vx-row border-left heading">
                <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                  {{ $t("setup.label.PlanCode") }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                  {{ $t("setup.label.ProductCode") }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                  {{ $t("setup.label.ChargeCode") }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                  {{ $t("setup.label.ChargeOwner") }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                  {{ $t("setup.label.Resource") }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                  {{ $t("setup.label.RoundingType") }}
                </div>
              </div>
            </div>
            <div class="vx-col w-2/5 less-padding">
              <div class="vx-row border-left heading" style="height: 100%">
                <!-- <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3">
                  {{ $t("setup.label.Discount") }}
                </div> -->
                <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3">
                  {{ $t("setup.label.Duration") }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3">
                  {{ $t("setup.label.GLID") }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3">
                  {{ $t("setup.label.Value") }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="vx-row less-padding"
            :key="index"
            :data="priceEl"
            v-for="(priceEl, index) in productPriceList"
          >
            <div class="vx-col w-3/5 less-padding">
              <div class="vx-row border-left py-2" style="height: 100%">
                <div
                  class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6"
                  style="word-wrap: break-word"
                >
                  {{ priceEl.planCode }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                  {{ priceEl.productCode }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                  {{ priceEl.chargeCode }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                  {{ priceEl.chargeOwner }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                  {{ priceEl.currencyCode }}
                </div>
                <div
                  class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6"
                  style="word-wrap: break-word"
                >
                  {{ priceEl.roundingType }}
                </div>
              </div>
            </div>
            <div class="vx-col w-2/5 less-padding">
              <div class="vx-row border-left py-2" style="height: 100%">
                <!-- <div
                  class="vx-col w-full sm:w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4"
                  style="word-wrap: break-word"
                >
                  <span class="ml-1">
                    {{ getDiscountCode(priceEl.discountId) }}</span
                  >
                </div> -->
                <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3">
                  {{ priceEl.duration }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3">
                  {{ priceEl.glId }}
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3">
                  {{ priceEl.price }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>

    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('setup.label.AddDiscount')"
        :active.sync="discountPopup"
        class="popup-close"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col sm:w-full w-full">
              <small class="font-semibold">{{
                $t("setup.label.DiscountCode")
              }}</small>
              <v-select
                label="discountCode"
                v-model="selectedDiscount"
                :options="productDiscounts"
                :placeholder="$t('placeholder.label.SelectOne')"
                :reduce="(name) => name.discountId"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full"
              />
            </div>
          </div>
          <div class="flex justify-center gap-6 mt-8 mb-4">
            <vs-button
              icon-pack="feather"
              type="border"
              icon="icon-x"
              @click="discountPopup = false"
              >{{ $t("customers.label.cancel") }}</vs-button
            >
            <vs-button
              icon-pack="feather"
              @click="addUpdateDiscount"
              icon="icon-search"
              >{{ $t("setup.label.Submit") }}</vs-button
            >
          </div>
        </form>
      </vs-popup>
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";

export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      createPriceArray: [],
      editPriceArray: [],
      chargeOwners: [
        { name: "Self", value: "self" },
        { name: "Parent", value: "parent" },
      ],
      prepaid: false,
      currencyCode: "",
      roundingTypes: [
        "RoundingUp",
        "RoundingDown",
        "RoundingHalf",
        "RoundingNearest",
      ],
      id: "",
      idPrice: "",
      editToggle: false,
      pricingData: [{}],
      productTypeId: "",
      chargeCode: "",
      chargeOwner: "",
      chargevariant: "",
      currencyId: "",
      discountId: "",
      isPrepaid: "",
      locale: "en",
      planCode: "",
      price: "",
      priceregion: "",
      productId: "",
      duration: "",
      roundingType: "",
      GLID: "",
      planPrice: "",
      isPriceUpdated: true,
      discountPopup: false,
      selectedDiscount: "",
      currentProductObj: {},
      currentProductIndex: "",
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      priceWithTemplate: (state) => state.planPrice.priceWithTemplate,
      productDiscounts: (state) => state.planPrice.productDiscounts,
    }),
    backRoute() {
      return { name: "View Plan", params: { id: this.$route.params.id } };
    },
    resourceOptions() {
      let exist = {
        id: this.priceWithTemplate.currencyId,
        code: this.priceWithTemplate.currencyCode,
      };
      if (Object.keys(this.priceWithTemplate).length) {
        return [
          exist,
          ...this.priceWithTemplate.currencydata.noncurrencyOptions,
        ];
      } else return [exist];
    },
    productPriceList() {
      let arr = [];

      this.editPriceArray.map((el) => {
        if (el.productCode && el.productCode != "NONE") {
          arr.push(el);
        }
      });

      return arr;
    },
    planPriceList() {
      let arr = [];

      this.editPriceArray.map((el) => {
        if (!el.productCode) {
          el.productCode = "NONE";
          arr.push(el);
        }
      });

      return arr;
    },
  },
  methods: {
    getDiscountCode(discountId) {
      const discount = this.priceWithTemplate.discountdata.find(
        (d) => d.id === discountId
      );
      return discount ? discount.discountCode : "N/A";
    },
    async addData() {
      if (
        this.$route.query &&
        this.$route.query.type &&
        Object.keys(this.$route.query.type).length
      ) {
        let product = this.priceWithTemplate.serviceData.find(
          (el) => el.productDescription == this.$route.query.type
        );
        this.productTypeId = product.id;
      }
      let Payload1 = {
        id: this.$route.params.id,
        planCode: this.priceWithTemplate.planCode,
        price: this.planPrice,
        chargeCode: this.chargeCode,
        duration: this.duration,
        isPrepaid: this.priceWithTemplate.isPrepaid === "N" ? false : true,
        currencyId: this.currencyId,
        productId: this.productTypeId,
        productCode: this.$route.query.type,
        discountId: this.selectedDiscount || 1,
        chargeOwner: this.chargeOwner,
        type: "c",
        chargevariant: this.priceWithTemplate.chargevariant[0].id,
        locale: "en",
      };
      try {
        await this.$store.dispatch("planPrice/addPriceAction", {
          id: this.id,
          data: Payload1,
        });
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Price added successfully!",
          type: "success",
        });
        this.getPriceWithTemplate();
        this.chargeCode = "";
        this.chargeOwner = "";
        this.chargevariant = "";
        this.currencyId = "";
        this.discountId = "";
        this.isPrepaid = "";
        this.locale = "en";
        this.planCode = "";
        this.price = "";
        this.priceregion = "";
        this.productId =
          this.$route.query &&
          this.$route.query.type &&
          Object.keys(this.$route.query.type).length
            ? this.productTypeId
            : "";
        this.duration = "";
        this.roundingType = "";
        this.GLID = "";
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async getPriceWithTemplate() {
      try {
        let template = await this.$store.dispatch(
          "planPrice/setPriceWithTemplate",
          this.id
        );
        this.priceWithTemplate.serviceData.push({
          productDescription: "NONE",
          id: 0,
        });
        this.editPriceArray = this.priceWithTemplate.pricingData.map((el) => {
          return { ...el };
        });
        this.editPriceArray.forEach((el) => {
          this.priceWithTemplate.priceRegionData.forEach((x) => {
            if (x.priceregion == el.priceregion) el.priceregion = x.id;
          });
        });

        this.editPriceArray.forEach((el) => {
          this.priceWithTemplate.chargeData.forEach((x) => {
            if (x.chargeDescription == el.chargeCode)
              el.chargeCode = x.chargeCode;
          });
        });
        this.editPriceArray.forEach((el) => {
          this.priceWithTemplate.chargevariant.forEach((x) => {
            if (x.value == el.chargeVariant) el.chargevariant = x.id;
            delete el.chargeVariant;
          });
        });
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    async editPrices() {
      this.isPriceUpdated = true;
      for (let temp of this.editPriceArray) {
        delete temp.contractId;
        delete temp.billingFrequency;
        delete temp.currencyCode;
        temp.discountId = temp.discountId || 1;
        temp.locale = "en";
        try {
          await this.$store.dispatch("planPrice/updatePriceAction", {
            id: temp.id,
            data: temp,
          });
        } catch (e) {
          this.isPriceUpdated = false;
          this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
            "The parameter",
            ""
          );
          this.warningPopup = true;
          this.errors = e.message.errors;
          break;
        }
      }
      if (this.isPriceUpdated) {
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Price updated successfully!",
          type: "success",
        });
        this.$router.push({ name: "Plan Pricing" });
      }
    },
    async addUpdateDiscount() {
      let payload = {
        chargeOwner:
          this.productPriceList[this.currentProductIndex].chargeOwner,
        planCode: this.productPriceList[this.currentProductIndex].planCode,
        isPrepaid: this.productPriceList[this.currentProductIndex].isPrepaid,
        productId: this.productPriceList[this.currentProductIndex].productId,
        discountId: this.selectedDiscount || "1",
        chargeCode: this.productPriceList[this.currentProductIndex].chargeCode,
        currencyId: this.productPriceList[this.currentProductIndex].currencyId,
        price: this.productPriceList[this.currentProductIndex].price.toString(),
        chargevariant:
          this.productPriceList[this.currentProductIndex].chargevariant,
        locale: "en",
        type: "D",
      };
      try {
        await this.$store.dispatch("planPrice/updatePriceAction", {
          id: this.currentProductObj.id,
          data: payload,
        });
        this.discountPopup = false;
      } catch (error) {
        this.$toasted.error(error.message);
      }
    },
    async deletePrice(id) {
      await this.$store.dispatch("planPrice/deletePriceAction", id);
      this.getPriceWithTemplate();
    },
    async getProductDiscountTemplate() {
      try {
        await this.$store.dispatch("planPrice/fetchProductDiscountTemplate");
      } catch (error) {
        this.$toasted.error(error.message);
      }
    },
  },
  async mounted() {
    this.id = this.$route.params.id;
    this.getProductDiscountTemplate();
    await this.getPriceWithTemplate();
  },
};
</script>

<style scoped>
.padding-zero {
  padding-top: 0px;
}
::v-deep .vs__selected-options {
  overflow: hidden;
  width: 100px;
  font-size: 12px;
  display: block;
}
.price-table >>> .vs-input--input.normal {
  width: 80px;
  font-size: 12px;
}
::v-deep .vs--searchable .vs__dropdown-toggle {
  height: 40px;
}
::v-deep .vs-table-text {
  display: block;
}
::v-deep .vs__selected {
  text-wrap: nowrap;
}
.less-padding .vx-row > .vx-col {
  padding: 0 4px;
}
::v-deep .vs-table--not-data {
  display: none;
}
</style>
<style lang="scss" scoped>
.w-13 {
  width: 8.5%;
  padding: 0 4px;
  max-width: 90px;
  &:last-child {
    width: 4%;
  }
}
.border-left {
  border-bottom: 1px solid rgba(var(--vs-primary), 0.3);
  div {
    &:not(:first-child) {
      border-left: 1px solid rgba(var(--vs-primary), 0.3);
    }
    &:nth-child(6) {
      border-right: 1px solid rgba(var(--vs-primary), 0.3);
    }
  }
}
.heading {
  font-weight: 600;
  font-size: 0.9rem;
  div {
    padding: 0.5rem 5px !important;
  }
}
.margin-bottom {
  width: 100%;
  border-bottom: 1px solid #777;
  margin-bottom: 20px;
}
</style>
